export type CheckoutProductType = 'autos' | 'hogar' | 'bundle';

const PRODUCTION_HOSTNAME = 'fulcro.connectasistencia.com';

// company=fulcro asigna la sub y el usuario al company Fulcro en Meraki (sin él quedan en connectpr).
// Los precios de cada ambiente deben estar ligados al company Fulcro y "fulcro" debe estar en el
// data-store allow_companies_param_checkout; si no, el checkout rechaza la compra.
const CHECKOUT_URLS: Record<'production' | 'staging', Record<CheckoutProductType, string>> = {
	production: {
		autos: 'https://fulcro.connect.inc/checkout?ids=79,80&country=pr&auto_pr=1&recurrence=ANNUAL&auto_pr_edit=false&addons_ids=89&company=fulcro',
		hogar: 'https://fulcro.connect.inc/checkout?ids=85,86,87,88&country=pr&hogar_premium=1&company=fulcro',
		// El bundle usa hogar_standard (la opción más económica) a propósito; hogar solo sigue en hogar_premium.
		bundle:
			'https://fulcro.connect.inc/checkout?ids=79,80,85,86,87,88&country=pr&auto_pr=1&recurrence=ANNUAL&auto_pr_edit=false&addons_ids=89&hogar_standard=1&company=fulcro',
	},
	staging: {
		autos: 'https://fulcro.stg.consoda.com/checkout?ids=74,75&country=pr&auto_pr=1&recurrence=ANNUAL&auto_pr_edit=false&addons_ids=80&company=fulcro',
		hogar: 'https://fulcro.stg.consoda.com/checkout?ids=78,79&country=pr&hogar_pr=1&company=fulcro',
		bundle:
			'https://fulcro.stg.consoda.com/checkout?ids=74,75,78,79&country=pr&auto_pr=1&recurrence=ANNUAL&auto_pr_edit=false&addons_ids=80&hogar_pr=1&company=fulcro',
	},
};

export const getCheckoutUrl = (productType: CheckoutProductType): string => {
	const environment = window.location.hostname === PRODUCTION_HOSTNAME ? 'production' : 'staging';
	return CHECKOUT_URLS[environment][productType];
};
